module.exports = "/lucky-balls/img/weager/Lower_Raise/Value_Holder.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Lower_Raise/Value_Holder.png
// module id = 1167
// module chunks = 0